$bog_vmap_app $mol_page
	doc_src \
	doc_css \
	spots? *
	guides? *
	selected? null
	picked? /string
	inner? \
	doc_js *
	doc_root \
	scene_bundle \
	links? \
	left_showed? true
	right_showed? true
	left_tab? \layers
	right_tab? \design
	code_showed? false
	history_showed? false
	history_state? *
	code_whole? false
	code_source? \
	code_js? \
	code_css? \
	root_js? \
	root_css? \
	lights? false
	store $bog_vmap_app_store
	title \vmap
	plugins /
		<= Theme $mol_theme_auto
			theme <= theme_name \$mol_theme_dark
		<= Tooltip $bog_tooltip_plugin
	sub /
		<= Head
		<= Main $mol_view
			attr *
				^
				inert <= doc_pending false
			sub <= main /$mol_view
		^ floats /$mol_view
	head /
		<= Left_check $mol_check_icon
			Icon <= Left_icon $mol_icon_dock_left
			hint \Левая колонка: сцены, слои и детали. Shift+\ прячет и возвращает обе колонки
			checked? <=> left_showed?
		<= Instruments $mol_bar
			attr *
				^
				inert <= doc_pending
			sub <= instruments /
				<= Tool_select $mol_check_icon
					Icon <= Tool_select_icon $mol_icon_cursor_default_outline
					hint \Выделение: клик выбирает узел, второй клик впускает внутрь. Клавиша V
					checked? <=> tool_select?
				<= Tool_board $mol_check_icon
					Icon <= Tool_board_icon $mol_icon_artboard
					hint \Артборд: клик по холсту ставит страницу 1280×720, тяга — страницу этого размера. Клавиша F
					checked? <=> tool_board?
					enabled <= editable true
				<= Tool_text $mol_check_icon
					Icon <= Tool_text_icon $mol_icon_format_text
					hint \Текст: клик ставит надпись по содержимому, тяга — надпись заданной ширины. Клавиша T
					checked? <=> tool_text?
					enabled <= text_enabled false
				<= Tool_hand $mol_check_icon
					Icon <= Tool_hand_icon $mol_icon_hand_back_right_outline
					hint \Рука: тяга двигает холст, пробел с тягой — то же на время. Клавиша H
					checked? <=> tool_hand?
				<= Delete $mol_button_minor
					title \Удалить
					hint <= delete_hint \
					enabled <= delete_enabled false
					click? <=> node_delete? null
		<= readonly_badge null
		<= Root_name $mol_string
			attr *
				^
				inert <= doc_pending
			enabled <= editable
			hint \Имя корневого класса
			value? <=> root_draft? \
			submit? <=> root_submit? null
			event *
				^
				blur? <=> root_submit? null
		<= Tools
	tools /
		<= Zoom_out $mol_button_minor
			title \−
			hint \Отдалить. Клавиша минус
			click? <=> zoom_out? null
		<= Zoom_reset $mol_button_minor
			title \Вписать всё
			hint \Показать всё. Shift+1 — всё, Shift+2 — выделенное
			click? <=> camera_reset? null
		<= Zoom_in $mol_button_minor
			title \+
			hint \Приблизить. Клавиша плюс
			click? <=> zoom_in? null
		<= History_check $mol_check_icon
			Icon <= History_icon $mol_icon_history
			hint \Версии: шаги этой сессии и снимки в ленде
			checked? <=> history_showed?
		<= Publish $bog_vmap_app_publish
			attr *
				^
				inert <= doc_pending
			foreign <= doc_readonly false
			part <= publish_part \
			source <= node_source? \
			js <= node_js \
			css <= root_css
			doc <= doc_src
			classes / <= doc_root
		<= Download $mol_button_download
			title <= export_title \
			hint <= export_hint \
			enabled <= export_ready false
			blob <= export_blob $mol_blob
			file_name <= export_file \
		<= Lights $mol_lights_toggle
			lights? <=> lights?
		<= Right_check $mol_check_icon
			Icon <= Right_icon $mol_icon_dock_right
			hint \Правая колонка: дизайн, код и версии. Shift+\ прячет и возвращает обе колонки
			checked? <=> right_showed?
	Left $mol_view
		sub /
			<= Scenes
			<= Left_tabs $mol_switch
				value? <=> left_tab?
				options *
					layers \Слои
					assets \Детали
			<= left_panel null
	Right $mol_view
		style *
			width <= right_width 272
		sub <= right_content /$mol_view
	Right_grip $mol_view
		attr *
			bog_vmap_app_right_grip \
			title \Ширина панели: тяните мышью, двойной клик вернёт обычную
		event *
			pointerdown? <=> grip_press? null
			dblclick? <=> grip_reset? null
	right_panel null
	Right_tabs $mol_switch
		value? <=> right_tab?
		options *
			design \Дизайн
			code \Код
			history \Версии
	Align $bog_vmap_app_align
		act*? <=> align_act*? null
		button_enabled* <= align_enabled* false
		note <= align_note \
	Canvas $mol_page
		title \Холст
		Body => Canvas_body
		Foot => Canvas_foot
		sub /
			<= Canvas_body
			<= Canvas_foot
		body /
			<= Pane $bog_vmap_app_pane
				editable <= editable
				scene_bundle <= scene_bundle
				pack_uri <= pack_script \
				theme <= scene_theme \
				doc_src <= doc_src
				doc_css <= doc_css
				spots? <=> spots?
				guides? <=> guides?
				picked? <=> picked?
				inner <= inner
				entered? <=> entered? null
				doc_js <= doc_js
				doc_root <= doc_root
				libs <= libs /$bog_vmap_bridge_part
				carrying <= carrying false
				wires <= doc_wires /$bog_vmap_lang_link
				part_ports* <= part_ports* /$bog_vmap_app_wire_port
				part_overs* <= part_overs* /string
				link_add? <=> link_add? null
				link_drop? <=> link_drop? null
				containers <= doc_containers /string
				doc_names <= doc_names /string
				doc_paths <= doc_paths /string
				doc_key <= doc_key \
				node_title? <=> node_title?
				axis* <= doc_axis* \
				tree_move? <=> tree_move? null
				carry_drop? <=> carry_drop? null
				files_drop? <=> files_drop? null
				node_delete? <=> node_delete?
				node_copy? <=> node_copy? null
				node_wrap? <=> node_wrap? null
				node_group? <=> node_group? null
				node_ungroup? <=> node_ungroup? null
				ungroup_enabled <= ungroup_enabled false
				node_reset_all? <=> node_reset_all? null
				reset_enabled <= reset_enabled false
				node_clone? <=> node_clone? null
				board_draw? <=> board_draw? null
				text_draw? <=> text_draw? null
				text_enabled <= text_enabled false
				node_resize? <=> node_resize? null
				node_text* <= node_text* \
				node_text_kind* <= node_text_kind* \
				node_text_write? <=> node_text_write? null
				tool_select? => tool_select?
				tool_board? => tool_board?
				tool_text? => tool_text?
				tool_hand? => tool_hand?
				node_show? => node_show?
		foot <= canvas_foot /$mol_view
	Scenes $bog_vmap_app_scenes
		store <= store
		face_brief <= face_brief \
		face_note <= face_note \
		face_who <= face_who \
		face_blob <= face_blob $mol_blob
		face_file <= face_file \
		face_draft? <=> face_draft? \
		face_take? <=> face_take? null
		face_status <= face_status \
	Layers $bog_vmap_app_layers
		source <= doc_src
		root <= doc_root
		doc_key <= doc_key \
		picked? <=> picked?
		inner? <=> inner?
		inner_kids* <= inner_kids* /string
		inner_class* <= inner_class* \
		inner_alien* <= inner_alien* false
		node_title? <=> node_title?
		node_title_note <= node_title_note
		tree_move? <=> tree_move?
		node_show? <=> node_show?
		editable <= editable
	Shelf $bog_vmap_app_shelf
		Title null
		editable <= editable
		links? <=> links?
		pack_link <= pack_link
		land_classes <= lib_classes /$mol_tree2
		class_list <= lib_class_list /string
		place? <=> shelf_place? \
	Inspect $bog_vmap_app_inspect
		source? <=> node_source? \
		peers <= node_peers /$mol_tree2
		pack <= pack_link \
		class_title? <=> node_title? \
		base? <=> node_base? \
		bases <= node_bases /string
		base_titles <= node_base_titles *
		sub_note \Готовые детали берутся в палитре: вкладка «Детали» слева, раздел «Готовые детали». Клик по детали ставит её на холст
		title_note <= node_title_note \
		renamable <= node_renamable true
		cell*? <=> node_cell*? null
		resettable* <= node_resettable* false
		reset*? <=> node_reset*? null
		share_able* <= node_share_able* false
		share_mark* <= node_share_mark* \
		share*? <=> node_share*? null
		share_unshare*? <=> node_share_unshare*? null
		shares <= node_shares /string
		share_uses* <= node_share_uses* \
		share_value*? <=> node_share_value*? $mol_tree2_empty
		editable <= node_editable true
	Idle $mol_page
		title \Свойства
		body /
			<= Idle_note $mol_paragraph
				title <= idle_note \Выберите узел на холсте, чтобы править его свойства
	Code $bog_vmap_app_code
		klass <= code_klass \
		prop <= code_prop \
		hooks <= code_hooks /string
		whole? <=> code_whole?
		source? <=> code_source?
		node_source? <=> node_source?
		js? <=> code_js?
		css? <=> code_css?
		error <= code_error \
		node_note <= code_node_note \
		editable <= node_editable
	Readonly $mol_chip
		title \Только просмотр
		hint \Чужая сцена: смотреть, выделять и читать свойства и код можно, правки выключены. «В библиотеку» делает копию детали в вашу библиотеку
	History $bog_vmap_app_history
		Title null
		store <= store
		state? <=> history_state?
	Lib $bog_vmap_lib_land_stack
		pack <= pack_link
		lands <= lands /string
	Status $mol_status
		status <= status \
	Foot_bar $mol_bar
		sub <= notes /$mol_view
	Zoom_chip $mol_button_minor
		title <= zoom_title \
		hint \Масштаб холста. Клик — сто процентов. Shift+0 и Cmd+0 — сто процентов, плюс и минус — шаг, Shift+1 — вписать всё, Shift+2 — вписать выделенное
		click? <=> zoom_full? null
	Alarm $mol_status
		status <= error \
	Inside_note $mol_paragraph
		title <= inside_note \
	Root_note $mol_paragraph
		title <= root_title_note \
	Export_row* $mol_paragraph
		title <= export_text* \
	pack_stalled false
	Stall $mol_bar
		sub <= stall_content /$mol_view
	Stall_note $mol_paragraph
		title <= stall_note \
	Stall_pack $mol_button_minor
		title \Вернуть пак по умолчанию
		hint \Убрать адрес библиотеки из полки и взять пак рядом со страницей редактора
		click? <=> pack_default? null
	Stall_reload $mol_button_minor
		title \Перезагрузить сцену
		hint \Поднять кадр заново. Документ хранится в редакторе и не потеряется
		click? <=> scene_restart? null
	Ghost $mol_view
		style *
			left <= ghost_left \0px
			top <= ghost_top \0px
		sub /
			<= ghost_title \
	event *
		^
		click? <=> chrome_click? null
